// src/pages/ResetPassword.jsx
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../api/axios';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    // Estrai il token dall'URL
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: '', type: '' });

        if (!token) {
            setMessage({ text: 'Token mancante. Clicca di nuovo sul link nell\'email.', type: 'danger' });
            return;
        }

        if (password !== confirmPassword) {
            setMessage({ text: 'Le password non coincidono.', type: 'danger' });
            return;
        }

        if (password.length < 8) {
            setMessage({ text: 'La password deve essere di almeno 8 caratteri.', type: 'danger' });
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await axios.post('/api_reset_password.php', JSON.stringify({
                token: token,
                password: password
            }));

            if (response.data.success) {
                setMessage({ text: response.data.message, type: 'success' });
                // Redirect al login dopo 3 secondi
                setTimeout(() => navigate('/login'), 3000);
            } else {
                setMessage({ text: response.data.message, type: 'danger' });
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Errore durante il reset della password.';
            setMessage({ text: errorMsg, type: 'danger' });
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!token) {
        return <div className="container mt-5 text-center alert alert-danger">Link non valido.</div>;
    }

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="card shadow-lg">
                        <div className="card-body p-4">
                            <h3 className="text-center mb-4">Imposta Nuova Password</h3>
                            
                            {message.text && (
                                <div className={`alert alert-${message.type} text-center`}>{message.text}</div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Nuova Password</label>
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        required 
                                        minLength="8"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Minimo 8 caratteri"
                                        autoComplete="new-password"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Conferma Password</label>
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        required 
                                        minLength="8"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Ripeti password"
                                        autoComplete="new-password"
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvataggio...' : 'Aggiorna Password'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;